module.exports = __webpack_public_path__ + "static/media/max.2f06f0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/max.png
// module id = 7361
// module chunks = 4